import React from 'react'
import { Stack, Text, Box } from '@chakra-ui/react'
import { DistributionReasonInfo } from '@Types'
import { numberToDollars } from '../../utils/numberToCurrency'

interface IraDistributionSectionProps {
  selectedReason: DistributionReasonInfo | null
  federalTaxWithholdingType: string
  federalTaxWithholdingAmountRaw: number
  federalTaxWithholdingAmountDisplay: string
  stateTaxWithholdingType: string
  stateTaxWithholdingAmountRaw: number
  stateTaxWithholdingAmountDisplay: string
  receivingInstitutionName?: string
}

const IraDistributionSection = ({
  selectedReason,
  federalTaxWithholdingType,
  federalTaxWithholdingAmountRaw,
  federalTaxWithholdingAmountDisplay,
  stateTaxWithholdingType,
  stateTaxWithholdingAmountRaw,
  stateTaxWithholdingAmountDisplay,
  receivingInstitutionName
}: IraDistributionSectionProps) => {
  return (
    <Stack spacing={2}>
      <Text as='h3' textStyle='h3'>
        Distribution Details
      </Text>
      <Stack spacing={4}>
        <Box>
          <Text fontWeight='bold'>Distribution Reason</Text>
          <Text>{selectedReason?.reason}</Text>
        </Box>
        {receivingInstitutionName && (
          <Box>
            <Text fontWeight='bold'>Receiving Institution Name</Text>
            <Text>{receivingInstitutionName}</Text>
          </Box>
        )}

        {selectedReason?.withholdingEnabled && !!federalTaxWithholdingType && (
          <Stack direction='row' w='100%' spacing={4}>
            <Box w='50%'>
              <Text fontWeight='bold'>Federal Tax Withholding Type</Text>
              <Text>{federalTaxWithholdingType}</Text>
            </Box>
            <Box w='50%'>
              <Text fontWeight='bold'>Federal Tax Withholding Amount</Text>
              <Text>
                {federalTaxWithholdingType === 'FIXED' && numberToDollars(federalTaxWithholdingAmountRaw)}
                {federalTaxWithholdingType === 'PERCENTAGE' && `${federalTaxWithholdingAmountDisplay}%`}
              </Text>
            </Box>
          </Stack>
        )}
        {selectedReason?.stateWithholdingEnabled && !!stateTaxWithholdingType && (
          <Stack direction='row' w='100%' spacing={4}>
            <Box w='50%'>
              <Text fontWeight='bold'>State Tax Withholding Type</Text>
              <Text>{stateTaxWithholdingType}</Text>
            </Box>
            <Box w='50%'>
              <Text fontWeight='bold'>State Tax Withholding Amount</Text>
              <Text>
                {stateTaxWithholdingType === 'FIXED' && numberToDollars(stateTaxWithholdingAmountRaw)}
                {stateTaxWithholdingType === 'PERCENTAGE' && `${stateTaxWithholdingAmountDisplay}%`}
              </Text>
            </Box>
          </Stack>
        )}
      </Stack>
    </Stack>
  )
}

export default IraDistributionSection
